// extracted by mini-css-extract-plugin
export default {"loadingOverlay":"MPArticleSkeleton_loadingOverlay__Ba+cE","loadingContent":"MPArticleSkeleton_loadingContent__uMK38","loadingText":"MPArticleSkeleton_loadingText__VUAE8"};